import { createReportBuffer } from './buffer'
import type { ReportDiagnosticSnapshot } from './buffer'
import type { RequestDiagnosticInput } from './redact'
import { REPORT_ACTION_IDS, REPORT_REQUEST_TEMPLATES } from './registry'

const newBuffer = () => createReportBuffer({
  actions: REPORT_ACTION_IDS,
  requestTemplates: REPORT_REQUEST_TEMPLATES,
})

let buffer = newBuffer()
let instance: object = {}

export interface ReportCaptureEpoch {
  instance: object
  generation: number
}

/** The host supplies an opaque canonical identity key only after eligibility checks. */
export function setProblemReportContext(contextKey: string | null): void {
  buffer.setContext(contextKey, contextKey !== null)
}

export function resetProblemReportCapture(): void {
  buffer.reset()
}

export function disposeProblemReportCapture(): void {
  buffer.destroy()
  buffer = newBuffer()
  instance = {}
}

export function problemReportSnapshot(): ReportDiagnosticSnapshot {
  return buffer.snapshot()
}

export function problemReportEpoch(): ReportCaptureEpoch {
  return { instance, generation: buffer.epoch() }
}

export function recordProblemReportFailure(input: RequestDiagnosticInput, epoch: ReportCaptureEpoch): void {
  if (epoch.instance === instance) buffer.pushRequest(input, epoch.generation)
}

export function recordProblemReportError(input: { name?: unknown; message?: unknown }, epoch: ReportCaptureEpoch): void {
  if (epoch.instance === instance) buffer.pushError(input, epoch.generation)
}

export function recordProblemReportAction(id: string, epoch: ReportCaptureEpoch): void {
  if (epoch.instance === instance) buffer.pushAction({ id }, epoch.generation)
}
